import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const state = {
    user: null
};

const mutations = {
    setUserData (state, userData) {
      state.user = userData;
      localStorage.setItem('userInfo', JSON.stringify(userData));
    },
    clearUserData () {
      localStorage.removeItem('userInfo');
      location.reload();
    }
};

const actions = {
    login ({ commit }, payload) {
      return axios.get(`//${process.env.VUE_APP_URL}/sanctum/csrf-cookie`).then(response => {
        return axios.post(`//${process.env.VUE_APP_URL}/login`, payload)
            .then(({ data }) => {
              commit('setUserData', data.data);
            });
      });
    },

    logout ({ commit }) {
      commit('clearUserData');
    }
};

const getters = {
    isLogged: state => !!state.user,
    currentUser: state => state.user
};

export default {
    state,
    actions,
    mutations,
    getters
};